import React from 'react';
import { Link } from 'react-router-dom';

const FirstPage = () => {
    return (
        <div style={{display:'flex',flexDirection:'row'}}>
        <div>
            <h1>Welcome to StudyApp</h1>
            <img style={{ width: '500px', height: '400px',margin:'10px',padding:'10px'}} src="https://www.makerstations.io/content/images/2022/03/olja-lobkis-studygram-04.jpeg" alt="Welcome" />
        </div>
        <div style={{display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center',marginLeft:'50px'}}>
            <Link to="/login"><p>Login</p></Link>
            <Link to="/register"><p>Register</p></Link>
        </div>
        </div>
    )
}
export default FirstPage;
